import { useTranslation } from "react-i18next";
import Label, { statusText } from "../../../components/Label";
import { useRecordContext } from "react-admin";

const mapStatementStatus = {
  DRAFT: { state: "warning" as const, text: "DRAFT" },
  VALIDATED: { state: "success" as const, text: "VALIDATED" },
  SENT: { state: "info" as const, text: "SENT" },
};

export const StatementStatusLabel = ({
  statusField = "status",
  record: propRecord = null,
}) => {
  const { t }: { t: any } = useTranslation();
  const recordContext = useRecordContext();
  const record = propRecord || recordContext;
  const status = record?.[statusField]?.toUpperCase() || "DRAFT";
  const { text, state } = mapStatementStatus[status] || mapStatementStatus.DRAFT;

  return <Label color={state}>{t(statusText(text))}</Label>;
};
